import { ServiceRequestBase } from "../ServiceRequestBase";

export class PageStatusRequest extends ServiceRequestBase {
  public PageName: string | null = null;
}
